// extracted by mini-css-extract-plugin
export default {"list":"MiniDrawer_list__SI5Am","isSelected":"MiniDrawer_isSelected__X1Ipi","isLogo":"MiniDrawer_isLogo__L4Vh-","icon":"MiniDrawer_icon__nYrV+","bold":"MiniDrawer_bold__HZJkc"};